import Signal from '../libs/signals';

const edoClaimsTrackingSignal = Signal({
  claims: [],
  dropdownFilters: {
    fundingProgramId: '',
    claimSubmittedDateFrom: '',
    claimSubmittedDateTo: '',
  },
  appliedFilters: {},
  recordsPerPage: 20,
  totalPages: 1,
  totalCount: 0,
});

export default edoClaimsTrackingSignal;
